import { H6 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexRow)<{ showBorder?: boolean }>`
  width: 100%;
  gap: 8px;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
  ${({ showBorder }) =>
    showBorder && `border-right: 1px solid ${themeStyle.varInkLight};`}
`;

export const SubUseCaseChipText = styled(H6)<{ isActive?: boolean }>`
  color: ${(props) =>
    props.isActive ? themeStyle.varInkMain : themeStyle.varInkMedium};
`;

export const SubUseCaseChip = styled.div<{ isActive?: boolean }>`
  padding: 6px 12px;
  border-radius: ${themeStyle.radiusSmall};
  border: 1px solid ${themeStyle.varInkLight};
  white-space: nowrap;
  background-color: ${(props) =>
    props.isActive ? themeStyle.varBackgroundAlt : ''};

  &:hover {
    background-color: ${themeStyle.varInkLight};

    ${SubUseCaseChipText} {
      color: ${themeStyle.varInkMain};
    }
  }
`;
